import { render, staticRenderFns } from "./EtapaFotoBiometria.vue?vue&type=template&id=1af3fbb5"
import script from "./EtapaFotoBiometria.vue?vue&type=script&lang=js"
export * from "./EtapaFotoBiometria.vue?vue&type=script&lang=js"
import style0 from "./EtapaFotoBiometria.vue?vue&type=style&index=0&id=1af3fbb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports